<template>
  <div class="columnlistBox">
    <div v-for="(item,index) in columnlist" :key="index" :class="index==columnlist.length-1? 'lastcolumn_li':'column_li'">
      <lisTemplate2 :list="item" :index="index" :isdoc="isdoc" />
    </div>
  </div>
</template>
<script>
import lisTemplate2 from '@/components/centerlist_news/listTemplate2/index.vue'
export default {
  components: { lisTemplate2 },
  props: ['columnlist', 'isdoc'],
  data() {
    return {
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .columnlistBox{
        margin-top:20px;
        font-size: 0;
        transform: translate(-10px,0);
        .column_li{
            width: 100%;
            height: 180px;
          margin-left: 10px;
          margin-bottom: 20px;
          background-color: #fff;
        }
      .lastcolumn_li{
        width: 100%;
        height: 180px;
        margin-left: 10px;
        background-color: #fff;
      }
    }
</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px){
    .columnlistBox{
      margin-top: 0;
      .column_li,.lastcolumn_li{
        height: auto;
        margin-bottom: 10px;
      }
    }
  }
</style>
